export default __webpack_public_path__ + "static/media/Skan.32ed7498.jpeg";